import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import QuickStartPage from "@/components/QuickStartPage.vue";
import ApiIntroduction from "@/components/ApiIntroduction.vue";
import Authentication from "@/components/Authentication.vue";
import DevelopmentGuide from "@/components/DevelopmentGuide.vue";
import Security from "@/components/Security.vue";
import ChangelogPage from "@/components/ChangelogPage.vue";
import NewCustomerPage from "../components/NewCustomerPage.vue";
import SignUrlPage from "../components/SignUrlPage.vue";
import TransactionQueryPage from "../components/TransactionQueryPage.vue";
import CustomerStatusPage from "../components/CustomerStatusPage.vue";
import FaqPage from "../components/FaqPage.vue";
import PaymentSubmitPage from "../components/paymentSubmitPage.vue";
import PaymentBatchSubmitPage from "../components/PaymentBatchSubmitPage.vue";
import PaymentGlobleSubmitPage from "../components/PaymentGlobleSubmitPage.vue";
import PaymentOverseasBatchSubmitPage from "../components/PaymentOverseasBatchSubmitPage.vue";
import PaymentOverseasStatusQueryPage from "../components/PaymentOverseasStatusQueryPage.vue";
import PaymentInternationalSubmitPage from "../components/PaymentInternationalSubmitPage.vue";
import PaymentGlobleSubmitRuleSearchPage from "../components/PaymentGlobleSubmitRuleSearchPage.vue";
import PaymentOverseasRuleSearchPage from "../components/PaymentOverseasRuleSearchPage.vue";
import PaymentThirdPartySubmitPage from "../components/PaymentThirdPartySubmitPage.vue";
import PaymentStatusQuery from "../components/paymentStatusQuery.vue";
import PaymentBatchStatusQuery from "../components/PaymentBatchStatusQuery.vue";
import PaymentBatchDetailStatusQuery from "../components/PaymentBatchDetailStatusQuery.vue";
import DailyBalance from "../components/DailyBalance.vue";
import ReceiptDownload from "../components/ReceiptDownload.vue";
import ReceiptBatchDownload from "@/components/ReceiptBatchDownload.vue";
import ReceiptMatchQuery from "@/components/ReceiptMatchQuery.vue";
import IconTest from "../components/IconTest.vue";
import { generatedRoutes } from "@/generated/routes";
import SDKAndDemoPage from "@/components/SDKAndDemoPage.vue";
import MonthStatementDownload from "@/components/MonthStatementDownload.vue";

// 获取基础路径配置（从环境变量）
const basePath = import.meta.env.VITE_DEFAULT_ROUTE_PATH || "/docs/v2/";

// 定义路由配置
const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: { name: "quick-start" },
  },
  {
    path: "/quick-start",
    name: "quick-start",
    component: QuickStartPage,
    meta: {
      title: "快速开始",
    },
  },
  {
    path: "/introduction",
    name: "introduction",
    component: ApiIntroduction,
    meta: {
      title: "API介绍",
    },
  },
  {
    path: "/sdk-demo",
    name: "sdk-demo",
    component: SDKAndDemoPage,
    meta: {
      title: "SDK & Demo",
    },
  },
  {
    path: "/authentication",
    name: "authentication",
    component: Authentication,
    meta: {
      title: "身份验证",
    },
  },
  {
    path: "/development-guide",
    name: "development-guide",
    component: DevelopmentGuide,
    meta: {
      title: "开发指南",
    },
  },
  {
    path: "/security",
    name: "security",
    component: Security,
    meta: {
      title: "安全概述",
    },
  },
  {
    path: "/new-customer",
    name: "new-customer",
    component: NewCustomerPage,
    meta: { title: "新建客户" },
  },
  {
    path: "/sign-url",
    name: "sign-url",
    component: SignUrlPage,
    meta: { title: "获取签约链接" },
  },
  {
    path: "/sign-status",
    name: "sign-status",
    component: CustomerStatusPage,
    meta: { title: "查询签约状态" },
  },
  {
    path: "/transaction-query",
    name: "transaction-query",
    component: TransactionQueryPage,
    meta: { title: "查询流水" },
  },

  {
    path: "/account-query",
    name: "account-query",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "查询银行账户",
    },
  },
  {
    path: "/daily-balance",
    name: "daily-balance",
    component: DailyBalance,
    meta: {
      title: "查询每日余额",
    },
  },
  {
    path: "/payment",
    name: "payment",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "支付",
    },
  },
  {
    path: "/payment/submit",
    name: "payment-submit",
    component: PaymentSubmitPage,
    meta: { title: "单笔支付制单" },
  },
  {
    path: "/payment/status-query",
    name: "payment-status-query",
    component: PaymentStatusQuery,
    meta: { title: "查询支付状态" },
  },
  // {
  //   path: "/payment/submit",
  //   name: "payment-submit",
  //   component: PaymentSubmitPage,
  //   meta: { title: "单笔支付制单" },
  // },
  {
    path: "/payment/international-submit",
    name: "payment-international-submit",
    component: PaymentInternationalSubmitPage,
    meta: { title: "跨境支付制单" },
  },
  {
    path: "/payment/global-submit",
    name: "payment-global-submit",
    component: PaymentGlobleSubmitPage,
    meta: { title: "全球汇款制单" },
  },
  {
    path: "/payment/global-submit-rule-search",
    name: "payment-global-submit-rule-search",
    component: PaymentGlobleSubmitRuleSearchPage,
    meta: { title: "全球汇款付款规则查询" },
  },
  {
    path: "/payment/global-submit-rule-search-v2",
    name: "payment-global-submit-rule-search-v2",
    component: PaymentOverseasRuleSearchPage,
    meta: { title: "境外汇款支付规则查询" },
  },
  {
    path: "/payment/third-party-submit",
    name: "payment-third-party-submit",
    component: PaymentThirdPartySubmitPage,
    meta: { title: "三方支付制单" },
  },
  {
    path: "/payment/status-query",
    name: "payment-status-query",
    component: PaymentStatusQuery,
    meta: { title: "查询支付状态" },
  },
  {
    path: "/payment/batch-submit",
    name: "payment-batch-submit",
    component: PaymentBatchSubmitPage,
    meta: { title: "批量转账(支付)制单" },
  },
  {
    path: "/payment/batch-status-query",
    name: "payment-batch-status-query",
    component: PaymentBatchStatusQuery,
    meta: { title: "查询批量转账(支付)状态" },
  },
  {
    path: "/payment/batch-detail-status-query",
    name: "payment-batch-detail-status-query",
    component: PaymentBatchDetailStatusQuery,
    meta: { title: "批量转账(支付)-明细支付状态查询" },
  },
  {
    path: "/payment/batch-global-pay",
    name: "payment-batch-global-pay",
    component: PaymentOverseasBatchSubmitPage,
    props: {
      title: "境外批量支付",
      apiPath: "/api/v2/payment/batchGlobalPay",
      description:
        "提交境外批量支付指令（POST /api/v2/payment/batchGlobalPay）。支付状态请使用「境外批量支付状态查询」接口。",
      interfaceDescription:
        "境外批量支付接口，用于提交跨境批量付款订单（请求体为嵌套 JSON，与对外 API 文档一致）。",
      submitLabel: "发起境外批量支付请求",
    },
    meta: { title: "境外批量支付" },
  },
  {
    path: "/payment/global-salary-pay",
    name: "payment-global-salary-pay",
    component: PaymentOverseasBatchSubmitPage,
    props: {
      title: "境外代发",
      apiPath: "/api/v2/payment/globalSalaryPay",
      description:
        "提交境外代发指令（POST /api/v2/payment/globalSalaryPay）。支付状态请使用「境外代发状态查询」接口。",
      interfaceDescription:
        "境外代发接口，用于提交跨境代发订单（请求体为嵌套 JSON，与对外 API 文档一致）。",
      submitLabel: "发起境外代发请求",
    },
    meta: { title: "境外代发" },
  },
  {
    path: "/payment/batch-global-pay-status",
    name: "payment-batch-global-pay-status",
    component: PaymentOverseasStatusQueryPage,
    props: {
      title: "境外批量支付状态查询",
      apiPath: "/api/v2/payment/batchGlobalPayStatus",
      description: "查询境外批量支付的汇总及明细支付状态",
    },
    meta: { title: "境外批量支付状态查询" },
  },
  {
    path: "/payment/global-salary-pay-status",
    name: "payment-global-salary-pay-status",
    component: PaymentOverseasStatusQueryPage,
    props: {
      title: "境外代发状态查询",
      apiPath: "/api/v2/payment/globalSalaryPayStatus",
      description: "查询境外代发的汇总及明细支付状态",
    },
    meta: { title: "境外代发状态查询" },
  },

  // 替换占位的下载回单路由，映射到 ReceiptDownload 组件
  {
    path: "/receipt-download",
    name: "receipt-download",
    component: ReceiptDownload,
    meta: { title: "回单下载" },
  },
  {
    path: "/receipt-batch-download",
    name: "receipt-batch-download",
    component: ReceiptBatchDownload,
    meta: { title: "回单批量下载" },
  },
  {
    path: "/receipt-match-query",
    name: "receipt-match-query",
    component: ReceiptMatchQuery,
    meta: { title: "回单匹配查询" },
  },
  {
    path: "/month-statement-download",
    name: "month-statement-download",
    component: MonthStatementDownload,
    meta: { title: "月度对账单下载" },
  },
  {
    path: "/other-query",
    name: "other-query",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "其他查询",
    },
  },
  {
    path: "/faq",
    name: "faq",
    component: FaqPage,
    meta: {
      title: "常见问题",
    },
  },
  {
    path: "/changelog",
    name: "changelog",
    component: ChangelogPage,
    meta: {
      title: "更新日志",
    },
  },
  {
    path: "/dev-guide",
    name: "dev-guide",
    component: DevelopmentGuide,
    meta: {
      title: "开发指南",
    },
  },
  {
    path: "/guide/getting-started",
    name: "guide-getting-started",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "入门指南",
    },
  },
  {
    path: "/guide/sdk-usage",
    name: "guide-sdk-usage",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "SDK使用",
    },
  },
  {
    path: "/guide/debugging",
    name: "guide-debugging",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "调试技巧",
    },
  },
  {
    path: "/guide/best-practices",
    name: "guide-best-practices",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "最佳实践",
    },
  },
  {
    path: "/guide/server-integration",
    name: "guide-server-integration",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "服务端集成",
    },
  },
  {
    path: "/guide/client-integration",
    name: "guide-client-integration",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "客户端集成",
    },
  },
  {
    path: "/sdk-libraries",
    name: "sdk-libraries",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "SDK和库",
    },
  },
  {
    path: "/tools",
    name: "tools",
    component: {
      template: '<div class="text-center text-xl p-8">页面建设中...</div>',
    },
    meta: {
      title: "工具",
    },
  },
  {
    path: "/icon-test",
    name: "icon-test",
    component: IconTest,
    meta: {
      title: "图标测试",
    },
  },
  ...generatedRoutes,
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(basePath),
  routes,
  // 设置滚动行为，切换路由时滚动到页面顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（比如浏览器前进后退），则返回保存的位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则滚动到页面顶部
    return { top: 0 };
  },
});

// 定义需要认证的路由白名单
const protectedRoutes = [
  "api-test", // API测试页面需要登录
  // 可以根据需要添加更多需要认证的路由名称
];

// 添加全局路由守卫，在进入系统前验证用户登录状态
router.beforeEach(async (to, from, next) => {
  try {
    // 如果是需要认证的页面，检查用户登录状态
    if (protectedRoutes.includes(to.name as string)) {
      // 从localStorage检查用户登录状态
      const userInfoStr = localStorage.getItem("userInfo");

      // 如果需要认证但未登录，跳转到登录页面
      if (!userInfoStr) {
        // 保存当前页面，以便登录后返回
        sessionStorage.setItem("redirectUrl", to.fullPath);
        // 在开发环境中使用配置的域名，生产环境中使用当前域名
        const isDev = import.meta.env.DEV;
        const baseUrl =
          isDev && import.meta.env.VITE_AUTH_DOMAIN
            ? import.meta.env.VITE_AUTH_DOMAIN
            : window.location.origin;
        const loginPath = "/#/passport/login";
        window.location.href = `${baseUrl}${loginPath}`;
        return;
      }

      try {
        // 验证localStorage中的用户信息是否有效
        const userInfo = JSON.parse(userInfoStr);
        if (!userInfo.userLogin) {
          // 用户信息无效，清除并跳转到登录页面
          localStorage.removeItem("userInfo");
          sessionStorage.setItem("redirectUrl", to.fullPath);
          // 在开发环境中使用配置的域名，生产环境中使用当前域名
          const isDev = import.meta.env.DEV;
          const baseUrl =
            isDev && import.meta.env.VITE_AUTH_DOMAIN
              ? import.meta.env.VITE_AUTH_DOMAIN
              : window.location.origin;
          const loginPath = "/#/passport/login";
          window.location.href = `${baseUrl}${loginPath}`;
          return;
        }
      } catch (parseError) {
        console.error("解析用户信息失败:", parseError);
        localStorage.removeItem("userInfo");
        sessionStorage.setItem("redirectUrl", to.fullPath);
        // 在开发环境中使用配置的域名，生产环境中使用当前域名
        const isDev = import.meta.env.DEV;
        const baseUrl =
          isDev && import.meta.env.VITE_AUTH_DOMAIN
            ? import.meta.env.VITE_AUTH_DOMAIN
            : window.location.origin;
        const loginPath = "/#/passport/login";
        window.location.href = `${baseUrl}${loginPath}`;
        return;
      }
    }

    // 设置页面标题
    const title = to.meta.title || "银企通™ API";
    document.title = `银企通™ API - ${title}`;

    // 继续导航
    next();
  } catch (error) {
    console.error("路由守卫验证登录状态时出错:", error);
    // 出错时也允许导航，避免阻止用户访问不需要认证的页面
    next();
  }
});

export default router;

// 删除文件末尾错误添加的重复routes数组
